import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { TableHelper } from '../../../../tables'

import { AssignmentTable } from '../../../../tables/assignment-table'

const Assignments = observer(() => {
  const match = useRouteMatch<any>('/content/topics/:id/assignments')
  const topicID = Number(match?.params.id)

  const { assignmentStore } = useStores()

  const [tableHelper] = useState(
    new TableHelper('list_topic_assignments', 'assignments', 'topics', topicID, 'active'),
  )

  useEffect(() => {
    if (assignmentStore.triggerRefresh) {
      tableHelper.load().then(() => assignmentStore.setTriggerRefresh(false))
    }
  }, [assignmentStore.triggerRefresh])

  return (
    <AssignmentTable
      forceLoading={assignmentStore.triggerRefresh}
      filter="active"
      tableHelper={tableHelper}
    />
  )
})

export const TopicsAssignmentsTab = (props: any) => {
  const { id } = props
  return {
    name: 'Assignments',
    path: `/content/topics/${id}/assignments`,
    component: () => <Assignments />,
  }
}
